import { Reveal, SectionLabel } from "./Reveal";
import { X, Check } from "lucide-react";

const problems = [
  "Kunden finden dich bei Google nicht — sie finden die Konkurrenz",
  "Die Seite lädt langsam und sieht auf dem Handy kaputt aus",
  "Besucher kommen, aber niemand ruft an oder schreibt",
  "Du weißt nicht mal, wer deine Seite betreut oder wo sie liegt",
];

const solutions = [
  "Du wirst lokal gefunden, wenn Kunden nach deiner Leistung suchen",
  "Blitzschnelle Ladezeit, perfekt auf jedem Smartphone",
  "Klare Handlungsaufforderungen, die Besucher zu Anfragen machen",
  "Ein fester Ansprechpartner, der sich um alles kümmert",
];

export default function ProblemSolution() {
  return (
    <section className="py-20 md:py-32">
      <div className="max-w-6xl mx-auto px-5 md:px-8">
        <Reveal>
          <SectionLabel number="01" label="Das Problem" />
          <h2 className="font-display font-medium text-3xl md:text-4xl lg:text-5xl tracking-tight max-w-2xl">
            Eine veraltete Website kostet dich jeden Monat Kunden.
          </h2>
          <p className="mt-5 text-base md:text-lg text-[#52525B] max-w-xl leading-relaxed">
            9 von 10 Kunden suchen heute zuerst online. Was sie dort sehen, entscheidet, ob sie
            anrufen — oder weiterklicken.
          </p>
        </Reveal>
        <div className="mt-14 grid md:grid-cols-2 gap-6">
          <Reveal delay={0.1}>
            <div className="h-full rounded-2xl border border-[#E4E4E7] bg-[#F8F9FA] p-8 md:p-10" data-testid="problem-card">
              <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#A1A1AA] mb-6">Ohne moderne Website</p>
              <ul className="space-y-5">
                {problems.map((p) => (
                  <li key={p} className="flex gap-3 text-[#52525B]">
                    <X className="w-5 h-5 shrink-0 text-[#A1A1AA] mt-0.5" aria-hidden="true" />
                    <span className="leading-relaxed">{p}</span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="h-full rounded-2xl border border-[#2563EB]/25 bg-white p-8 md:p-10 shadow-[0_20px_50px_-20px_rgba(37,99,235,0.2)]" data-testid="solution-card">
              <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#2563EB] mb-6">Mit SA Webdesign</p>
              <ul className="space-y-5">
                {solutions.map((s) => (
                  <li key={s} className="flex gap-3">
                    <Check className="w-5 h-5 shrink-0 text-[#2563EB] mt-0.5" aria-hidden="true" />
                    <span className="leading-relaxed font-medium">{s}</span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
